
import React, { lazy, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useLocation, useParams,Navigate } from "react-router-dom";
import { userSelector } from "../redux/Selectors";
import NotFound from "../pages/NotFound";
import { useTranslation } from "react-i18next";

const AboutUs = lazy(() => import("../pages/AboutUs/index"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const MyAccount = lazy(() => import("../pages/MyAccount/index"));
const Landing = lazy(() => import("../pages/Landing/index"));
const NewProjects = lazy(() => import("../pages/NewProjects"));
const FindAgent = lazy(() => import("../pages/FindAgent"));
const AgentDetail = lazy(() => import("../pages/AgentDetail"));
const Mortgages = lazy(() => import("../pages/Mortgages"));
const ProjectDetail = lazy(() => import("../pages/ProjectDetail"));
const PropertyDetail = lazy(() => import("../pages/PropertyDetail"));
const Properties = lazy(() => import("../pages/Properties/index"));

const LangRoutes = () => {
  const { lang } = useParams();
  const user = useSelector(userSelector);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="new-projects" element={<NewProjects />} />
      <Route path="about-us" element={<AboutUs />} />
      <Route path="contact-us" element={<ContactUs />} />
      <Route path="find-agent" element={<FindAgent />} />
      <Route path="project-detail" element={<ProjectDetail />} />
      <Route path="property-detail" element={<PropertyDetail />} />
      <Route path="agent-detail/:id" element={<AgentDetail />} />
      <Route path="mortgages" element={<Mortgages />} />
      <Route path="buy" element={<Properties type="buy" />} />
      <Route path="rent" element={<Properties type="rent" />} />
      <Route path="commercial" element={<Properties type="commercial" />} />
      {user && <Route path="my-account" element={<MyAccount />} />}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/en" replace />} />
      <Route path="/:lang/*" element={<LangRoutes />} />
    </Routes>
  );
};

export default AppRouter;

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
